var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('float-input',_vm._g({attrs:{"field":_vm.field,"data":_vm.data}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }